<template>
  <i class="font-awesome-icon-compat" :class="icon"></i>
  <!-- <font-awesome-icon :icon="icon" class="font-awesome-icon-compat" /> -->
</template>

<script lang="ts">
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default defineComponent({
  // components: {
  //   FontAwesomeIcon
  // },
  props: {
    icon: {
      type: String,
      required: true
    }
  }
});
</script>

<style lang="scss" scoped>
.font-awesome-icon-compat {
  display: inline-block;
  text-align: center;
}
</style>
